module.exports = __webpack_public_path__ + "static/media/icon-hamburger-open.77a52ad2.svg";